import { compose, lifecycle, branch, withState, renderComponent } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withNotifications } from '@components/hoc/withNotifications';
import * as T from '@components/hoc/entityDetailEnhancer/_entityDetailTypes';

import { Loader } from '@components/loader';

const EntityDetailEnhancer = <TOriginalProps extends T.EntityDetailEnhancerProps<TEntity>, TEntity>({
  getEntity,
  defaultEntity
}: TOriginalProps) =>
  compose<TOriginalProps, T.Outter>(
    withNotifications({ getEntity }),
    withRouter,
    withState<{}, boolean, string, string>('fetchingEntity', 'toggleFetchingEntity', true),
    lifecycle<T.Outter & TOriginalProps & TEntity & { getEntityNotify: any }, {}, {}>({
      async componentDidMount() {
        const { item, toggleFetchingEntity, injectedGetEntityProps, getEntityNotify } = this.props;
        if (item) {
          let entity: TEntity;
          try {
            entity = await getEntityNotify(item, injectedGetEntityProps);

            this.setState({ entity });
          } catch {
            this.setState({ entity: defaultEntity });
          }
        }
        toggleFetchingEntity(false);
      }
    }),
    branch(({ fetchingEntity }) => fetchingEntity, renderComponent(Loader))
  );

export default EntityDetailEnhancer;



// WEBPACK FOOTER //
// ./src/components/hoc/entityDetailEnhancer/EntityDetailEnhancer.ts